import { reducerFromMap } from './common.reducers';

import {
  COMPRESSOR_LOAD,
  COMPRESSOR_LOAD_COMPLETE,
  COMPRESSOR_LOAD_ERROR,
  DATALAYOUT_LOAD,
  DATALAYOUT_LOAD_COMPLETE,
  DATALAYOUT_LOAD_ERROR,
} from '../actions';
import {
  digestCompressorData,
  normalizeTreeStructure,
} from '../libs/dataUtils';

const initialState = {
  loading: false,
  message: null,

  id: null,
  data: null,

  dataLayout: null,
  dataLayoutLoading: false,

  mode: 'read',

  projectUpdates: {},
  structureUpdates: [],

  confirmRequest: false,

  ready: false,
};

const reducerMap = {};

reducerMap[COMPRESSOR_LOAD] = (state, action) => ({
  ...state,
  loading: true,
  ready: false,
  message: null,
  data: null,
});

reducerMap[COMPRESSOR_LOAD_COMPLETE] = (state, action) => {
  if (state.dataLayout) {
    digestCompressorData(action.data, state.dataLayout.tree);
  }

  return {
    ...state,
    loading: false,
    ready: !state.dataLayoutLoading,
    message: null,
    mode: 'read',
    data: action.data,
  };
};

reducerMap[COMPRESSOR_LOAD_ERROR] = (state, action) => ({
  ...state,
  loading: false,
  ready: false,
  message: action.error.message,
});

reducerMap[DATALAYOUT_LOAD] = (state, action) => ({
  ...state,
  dataLayoutLoading: true,
  ready: false,
  message: null,
  dataLayout: null,
});

reducerMap[DATALAYOUT_LOAD_COMPLETE] = (state, action) => {
  normalizeTreeStructure(action.data.tree);
  let { data, loading } = state;

  if (data) {
    digestCompressorData(data, action.data.tree);
    data = { ...data };
  }

  return {
    ...state,
    id: action.data.id,
    dataLayoutLoading: false,
    ready: !loading && !!data,
    message: null,
    dataLayout: action.data,
    data,
  };
};

reducerMap[DATALAYOUT_LOAD_ERROR] = (state, action) => ({
  ...state,
  dataLayoutLoading: false,
  message: action.error.message,
});

export default reducerFromMap(reducerMap, initialState);
